import React from 'react';

// Custom Mobile Crane icon - depicts a truck-mounted crane with extended boom
const MobileCraneIcon = ({ className = "", size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Crane boom/jib extending diagonally upward */}
      <line x1="9" y1="11" x2="3" y2="3" />
      
      {/* Hook assembly at end of boom */}
      <path d="M3 3 L3 5.5 C3 6.5 4 7 4.5 7 C5 7 6 6.5 6 5.5 L6 4.5" />
      
      {/* Boom pivot/base */}
      <circle cx="9" cy="11" r="1.5" />
      
      {/* Truck cabin */}
      <path d="M2 14 L2 17.5 C2 18 2.5 18.5 3 18.5 L6 18.5 L6 14 L2 14 Z" />
      
      {/* Truck bed/chassis */}
      <path d="M6 15 L16 15 L16 18.5 L6 18.5 Z" />
      
      {/* Crane superstructure on truck */}
      <rect x="7" y="11" width="5" height="4" rx="0.5" />
      
      {/* Front wheel */}
      <circle cx="4" cy="19.5" r="1.5" />
      
      {/* Rear wheels */}
      <circle cx="13" cy="19.5" r="1.5" />
      
      {/* Outrigger/stabilizer legs */}
      <line x1="17" y1="15" x2="20" y2="18" />
      <line x1="20" y1="18" x2="22" y2="18" />
      <line x1="17" y1="18" x2="20" y2="21" />
      <line x1="20" y1="21" x2="22" y2="21" />
    </svg>
  );
};

export default MobileCraneIcon;
